import React, { useState, useEffect } from 'react';

function User({ userID, onClick }) {
    const [user, setUser] = useState({});

    useEffect(() => {
        fetch(`https://dummyjson.com/user/${userID}`)
            .then(response => response.json())
            .then(data => setUser(data));
    }, [userID]);
    
    return (
        <div>
            {user ? (
                <div className="user">
                    <a href={'#'+ user.id} onClick={() => onClick(user.id)}>
                        <img src={"https://i.pravatar.cc/30?img=" + user.id} alt='Alternative text' className='icon'/>
                        <span>{user.firstName} {user.lastName}</span>
                    </a>
                    
                </div>
            ) : (
                <p>Loading...</p>
            )}
        </div>
    );
}

export default User;
